module.exports = __webpack_public_path__ + "files/61eb5355c6f5cafae6ce9125143235d2.png";